import {formatCurrency} from '../util/format.mjs';

const formatNotificationValues = (format, values) => {
  switch (format.toLowerCase()) {
    case '%':
    case 'percent':
      return values.map((value) => {
        return `${value}%`;
      });
    case 'number':
      return values.map((value) => {
        return value.toLocaleString();
      });
    case '$':
    case 'money':
    case 'currency':
      return values.map((value) => {
        return formatCurrency(value);
      });
    default:
      return values;
  }
};

export default formatNotificationValues;
